import React from "react";
import { Input } from "antd";
import noop from "lodash/noop";
import PropTypes from "prop-types";
class InputEditor extends React.Component{
    render() {
        return React.createElement(Input, {
            placeholder: this.props.placeholder,
            onChange: this.props.onChange || noop,
            onBlur: this.props.onBlur || noop,
            prefix: this.props.prefix,
            disabled: this.props.disabled,
            step: this.props.isFloat ? 0.01 : 0,
            size: this.props.size || "default",
            type: this.props.type || "number"
        });
    }
}

InputEditor.propTypes = {
    placeholder: PropTypes.string,
    onChange: PropTypes.string,
    onBlur: PropTypes.string,
    prefix: PropTypes.string,
    disabled: PropTypes.string,
    size: PropTypes.string,
    grouped: PropTypes.string,
    addBefore: PropTypes.string,
    addAfter: PropTypes.string,
    type: PropTypes.string,
    isFloat: PropTypes.bool
};

export default InputEditor;